/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeneralAttachmentModel } from '../../models/general-attachment-model';

export interface GetTargetAttachments$Params {
  targetID?: number;
  includeArchived?: boolean;
}

export function GetTargetAttachments(http: HttpClient, rootUrl: string, params?: GetTargetAttachments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GeneralAttachmentModel>>> {
  const rb = new RequestBuilder(rootUrl, GetTargetAttachments.PATH, 'get');
  if (params) {
    rb.query('targetID', params.targetID, {});
    rb.query('includeArchived', params.includeArchived, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GeneralAttachmentModel>>;
    })
  );
}

GetTargetAttachments.PATH = '/api/Supervisor/GetTargetAttachments';
